export function requireSuccessfulResponse(response) {
  if (!response || response.success !== true) {
    const error = new Error((response && response.message) || 'API 請求失敗')
    error.code = response && response.code
    throw error
  }

  return response.data
}

function phaseThreeError(response, fallbackMessage = 'API 請求失敗') {
  const payload = response && response.body !== undefined ? response.body : response
  const error = new Error((payload && payload.message) || fallbackMessage)
  error.code = payload && payload.code
  error.httpStatus = response && response.httpStatus
  return error
}

// Phase 3 endpoints deliberately use standard HTTP status codes and may return
// raw DTOs/lists, 201 bodies, 204 without a body, or the legacy success/data
// envelope. Keep that transport diversity at this boundary instead of leaking
// response-shape checks into individual screens.
export function normalizePhaseThreeResponse(response) {
  let payload = response

  if (response && response.__httpResponse === true) {
    const status = Number(response.httpStatus)
    if (!Number.isInteger(status) || status < 200 || status >= 300) {
      throw phaseThreeError(response)
    }
    if (status === 204) return null
    payload = response.body
  }

  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    if (Object.prototype.hasOwnProperty.call(payload, 'success')) {
      if (payload.success !== true) throw phaseThreeError(payload)
      return payload.data
    }
  }

  if (payload === undefined) {
    throw phaseThreeError(payload, 'API 回應格式不正確')
  }

  return payload
}

export function toPhaseThreePagedResult(response) {
  const payload = normalizePhaseThreeResponse(response)

  if (Array.isArray(payload)) {
    return { items: payload, total: payload.length }
  }

  if (!payload || typeof payload !== 'object') {
    return { items: [], total: 0 }
  }

  const items = Array.isArray(payload.items)
    ? payload.items
    : Array.isArray(payload.data)
      ? payload.data
      : []
  const parsedTotal = Number(payload.total)
  return {
    items,
    total: Number.isFinite(parsedTotal) ? parsedTotal : items.length,
  }
}

export function toPagedResult(response) {
  const payload = requireSuccessfulResponse(response) || {}

  if (Array.isArray(payload)) {
    return { items: payload, total: payload.length }
  }

  const items = Array.isArray(payload.items)
    ? payload.items
    : Array.isArray(payload.data)
      ? payload.data
      : []

  const parsedTotal = Number(payload.total)
  return {
    items,
    total: Number.isFinite(parsedTotal) ? parsedTotal : items.length,
  }
}
